import { h, Fragment } from "preact";
import ProductOptionImagePill from "./product-option-image-pill";
import ProductOptionSummary from "./product-option-summary";
import ProductOptionSizeNote from "./product-option-size-note";

export default function ProductOptionImagePills({
  optionValues,
  optionName,
  optionNumber,
  updateOptionValue,
  selectedOptionValue,
  disabledOptionValues = [],
  openByDefault,
  sizeNote,
}) {
  return (
    <conditional-details>
      <details
        className="product-options__option-details product-options__image-pills"
        open={openByDefault}
      >
        <ProductOptionSummary
          optionName={optionName}
          optionNumber={optionNumber}
          selectedOptionValue={selectedOptionValue}
        />
        <div className="product-options__option-content" data-content>
          <div className="product-options__option-content-inner">
            <fieldset className="product-options__image-pill-list">
              <legend className="visually-hidden">{optionName}</legend>
              {optionValues.map((optionValue) => (
                <ProductOptionImagePill
                  key={optionValue.name}
                  optionValue={optionValue}
                  optionName={optionName}
                  disabled={disabledOptionValues.includes(optionValue.name)}
                  updateOptionValue={updateOptionValue}
                  selected={optionValue.name === selectedOptionValue}
                />
              ))}
            </fieldset>
            <ProductOptionSizeNote sizeNote={sizeNote} />
          </div>
        </div>
      </details>
    </conditional-details>
  );
}
